function bigSliderOpen() {
	const newsSlider = document.querySelector('.news-slider')
	const newsSliderBig = document.querySelector('.news-slider--big')

	const wrapperBig = document.querySelector('.swiper-wrapper--big')
	const overlayNews = document.querySelector('.news__overlay')
	const slideSlider = document.querySelectorAll('.slide-img')
	slideSlider.forEach(image => {
		image.addEventListener('click', e => {
			newsSliderBig.style.display = 'block'
			wrapperBig.style.display = 'flex'
			overlayNews.style.display = 'block'
		})
	})
}
